/**
 * Déconnexion : efface ce que l'utilisateur a laissé dans le navigateur (appareil partagé).
 * localStorage, sessionStorage et caches du service worker, sauf le precache Workbox (coquille de l'app,
 * aucune donnée métier) pour que l'application reste utilisable hors ligne après la déconnexion.
 */
export const clearBrowserStorage = async (): Promise<void> => {
  try { localStorage.clear(); } catch { /* stockage indisponible (navigation privée) */ }
  try { sessionStorage.clear(); } catch { /* idem */ }
  if (typeof caches === 'undefined') return;
  try {
    const names = await caches.keys();
    await Promise.all(names.filter((n) => !n.startsWith('workbox-precache')).map((n) => caches.delete(n)));
  } catch { /* Cache API refusée (contexte non sécurisé) */ }
};
